import { useEffect } from "react";
import { trackEvent } from "@leafly-com/web-utils";

import NuggMdLogo from "./nuggmdlogo.svg";

const NuggMdPlacement = () => {
  useEffect(() => {
    trackEvent("NuggMD Banner", "impression", "doctor finder");
  }, []);

  return (
    <a
      href="https://www.nuggmd.com/leafly?promo_code=LEAFLY10&utm_campaign=leafly23"
      rel="noreferrer"
      target="_blank"
      onClick={() => trackEvent("NuggMD Banner", "click", "doctor finder")}
    >
      <div className="nuggmd rounded p-lg text-white flex flex-col justify-between cursor-pointer my-lg">
        <h3>Get your medical marijuana card today & save $10</h3>
        <div>
          Code: <span className="font-bold">LEAFLY10</span>
        </div>
        <div className="flex flex-row items-center justify-between">
          <div className="font-semibold underline">visit nuggmd.com</div>
          <NuggMdLogo />
        </div>

        <style jsx>{`
          .nuggmd {
            background-color: #294a79;
            height: 156px;
          }
        `}</style>
      </div>
    </a>
  );
};

export default NuggMdPlacement;
